import { ECOPROTOKEN_CLAIMS, HWINC_DEVICEUSAGE_TYPES, LOCALSESSIONDATAKEYS } from "../../constants/AppConstants";
import { getLanguagePrefix } from "../Internationalization/handleAppInternationalization";
import { WEB_handleSelectedPlanLocalData, getLocalSessionData, getUserSessionData } from "../Authentication/handleUserSession";

const HW_INCLUSIVE_InstantPaymentPayload = (preEnrollId, accountInfo) =>  {
    const UID = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
    const deviceModel = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL);
    const langCode = getLanguagePrefix();
    const planInfo = WEB_handleSelectedPlanLocalData("Get");
    const {
        address,
        addressLine2 = "",
        city,
        province = "",
        postcode,
        country           
    } = accountInfo?.subscriptionPayload?.accountDetails?.shippingAddress;
   
    return {
        "userId": UID,
        "upfrontFeePlanIds": [
          planInfo?.HWPlans?.planId
        ],
        "shippingAddress": {
          "street1": address,
          "street2": addressLine2 || "",
          "city": city,
          "state": province || "",
          "postalCode": postcode,
          "country": country,
          languageCode: langCode
        },
        "preEnrollId": preEnrollId,
        "ModelNumber": deviceModel,
        "DeviceUsageTypeId": planInfo?.HWPlans?.deviceUsageType,
        "UpfrontFeeDiscountPlanIds": (planInfo?.HWPlans?.deviceUsageType === HWINC_DEVICEUSAGE_TYPES.NEW_PRINTER_BUNDLE.ID )
            ? [planInfo?.HWPlans?.discountId] 
            : null,
      }
      
}

export default HW_INCLUSIVE_InstantPaymentPayload;